export default __webpack_public_path__ + "static/undraw_weather_d9t2-b0f19a76ceea68774ffd027b8df72bb3.svg";